export const FILETYPE = [".rel", ".pdf", ".tar", ".tar.gz", ".gz"];

export const DATES = ["mon", "tues", "wed", "thur", "fri", "sat", "sun"];

export const DATESNUMBER = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
];

export const PROFILESTYPE = {
  1: ["Program", "Menu", "Module", "Operation"], //Culture = 1 - Inglés
  2: ["Programa", "Menu", "Módulo", "Operación"], //Culture = 2 - Español
  3: ["Program", "Menu", "Module", "Operation"], //Culture = 3 - Portugues
};

export const STATUSCODE = {
  Unauthorized: 401,
  Created: 201,
  Ok: 200
};

export const CompanyURL = "https://www.delsatgroup.com/";
